/**
 * Moves Shopify Shop Pay Installments (.shopify-payment-terms) under the price block.
 * Hides the Shop Pay card wrapper when installments are unavailable (empty terms).
 */
(function () {
  var bootPending = false;

  function termsHasContent(terms) {
    if (!terms) return false;

    try {
      if (terms.shadowRoot) {
        var shadowText = (terms.shadowRoot.textContent || '').replace(/\s+/g, ' ').trim();
        if (shadowText.length > 0) return true;
      }
    } catch (e) {
      /* closed/inaccessible shadow root — fall through to light DOM */
    }

    var text = (terms.textContent || '').replace(/\s+/g, ' ').trim();
    if (text.length > 0) return true;

    if (terms.querySelector && terms.querySelector('shop-pay-wallet-button, [data-shopify-payment-terms], iframe')) {
      return true;
    }

    return false;
  }

  function syncShopPayCard(meta) {
    var below = meta.querySelector('.cb-price-stack__below--shop-pay-only');
    if (!below) return;

    var anchor = meta.querySelector('[data-shop-pay-terms-anchor]');
    var terms =
      (anchor && anchor.querySelector('.shopify-payment-terms')) ||
      meta.querySelector('form.product-single__form .shopify-payment-terms');

    if (termsHasContent(terms)) {
      below.style.removeProperty('display');
      below.removeAttribute('data-shop-pay-unavailable');
      below.hidden = false;
    } else {
      below.style.setProperty('display', 'none', 'important');
      below.setAttribute('data-shop-pay-unavailable', 'true');
      below.hidden = true;
    }
  }

  function moveTermsInMeta(meta) {
    if (!meta) return;

    var anchor = meta.querySelector('[data-shop-pay-terms-anchor]');
    var form = meta.querySelector('form.product-single__form');
    if (!anchor || !form) return;

    var terms = form.querySelector('.shopify-payment-terms');
    if (terms && terms.parentElement !== anchor) {
      anchor.appendChild(terms);
    }

    syncShopPayCard(meta);
  }

  function boot() {
    document.querySelectorAll('.product-single__meta').forEach(moveTermsInMeta);
  }

  function scheduleBoot() {
    if (bootPending) return;
    bootPending = true;
    window.requestAnimationFrame(function () {
      bootPending = false;
      boot();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('variant:change', function () {
    scheduleBoot();
    window.setTimeout(boot, 250);
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target) return;
    if (
      target.matches('[data-product-select]') ||
      target.matches('.product-single__variants') ||
      target.closest('.variant-input-wrap')
    ) {
      scheduleBoot();
      window.setTimeout(boot, 300);
    }
  });

  var observer = new MutationObserver(function () {
    scheduleBoot();
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('form.product-single__form').forEach(function (form) {
      observer.observe(form, { childList: true, subtree: true });
    });
    window.setTimeout(boot, 500);
    window.setTimeout(boot, 1500);
    window.setTimeout(boot, 3000);
  });
})();
